import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MotivoTransicao } from '../../../../../shared/services/models/vendas/motivo-transicao.model';

export interface PvMotivoDialogData {
    /** Nome da etapa de destino — é ela quem exige o motivo. */
    nomeDestino: string;
    /** Motivos aceitos neste destino, já filtrados pelo shell. */
    motivos: MotivoTransicao[];
}

export interface PvMotivoDialogResult {
    idMotivoTransicao: number;
    justificativa: string | null;
}

/**
 * Painel de motivo obrigatório.
 *
 * Quem exige é a etapa de DESTINO, não a origem: o motivo responde "por que o documento entrou
 * aqui". Fechar sem confirmar devolve `undefined`, e o shell interpreta isso como desistência —
 * o card volta para a coluna de origem.
 */
@Component({
    selector: 'app-pv-motivo-dialog',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
    ],
    templateUrl: './pv-motivo-dialog.component.html',
    styleUrls: ['./pv-motivo-dialog.component.css'],
})
export class PvMotivoDialogComponent {
    public idMotivoTransicao: number | null = null;
    public justificativa = '';

    constructor(
        public dialogRef: MatDialogRef<PvMotivoDialogComponent, PvMotivoDialogResult>,
        @Inject(MAT_DIALOG_DATA) public data: PvMotivoDialogData,
    ) {}

    public get temMotivos(): boolean {
        return this.data.motivos.length > 0;
    }

    public confirmar(): void {
        if (this.idMotivoTransicao == null) return;

        this.dialogRef.close({
            idMotivoTransicao: this.idMotivoTransicao,
            justificativa: this.justificativa.trim() || null,
        });
    }

    public cancelar(): void {
        this.dialogRef.close();
    }
}
